import React, {Component} from 'react';
import Typist from 'react-typist';

export default class TypewriterText extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="typist">
      <Typist
        avgTypingDelay={49}
        startDelay={this.props.delay}
      >
        {this.props.text}
        {this.props.back ? <Typist.Backspace count={4} delay={1000} /> : <></> }
        {this.props.delay ? <Typist.Delay ms={1400} /> : <></> }
      </Typist>
    </div>;
  }
}